import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import AutocompletesAsyncS from '@/vuetify_custom/v-form/components/Autocompletes_Async.js'
import styles from './plan_modal.module.less'
import { updateCostPlanBillApi } from './../services'
import plan_form from '../mixins/plan_form'
import { pre_to } from './../fields'
const need_keys = [
    'id', 
    'team_id',
    'company_id', 
    'apply_user_id',
    'payee_bank',
    'payee_bank_number',
    'payee_account_name',
    'payee_company_id',
    'payee_company_account_id',
    'contract_id',
    'end_at',
    'start_at',
    'name'
]

export default {
    mixins: [ plan_form ],
    data() {
        return {
            title: '编辑',
            value: {},
        }
    },
    computed: {
        fields() {
                return [
                  this.apply_user_field,
                  this.fill_user_field,
                  this.company_field,
                  this.team_filed,
                  this.bills_name,
                  this.contract_field,
                  this.payee_company_account_field,
                ]
              }
    },
    created() {
    
    },
    methods: {
        initValue(data) {
          const contract = data.contract || {}
            need_keys.forEach(key => {
                this.$set(this.value, key, data[key])
            })
            // 申请人数据回选展示
            this.apply_user_list = [
                {
                    id: data.apply_user_id,
                    account: data.apply_user
                }
            ]
            // 关联合同 
            this.contract_list = [
                {
                    id: data.contract_id,
                    ...contract,
                    text_name: `${contract.uid}-${contract.name}`
                }
            ]
            // 搜款账户
            const account_payee = {}
            pre_to.forEach(([pre, cur]) => {
                account_payee[pre] = data[cur]
            })
            account_payee.text_name = `${account_payee.bank_number}-${account_payee.bank_account}-${account_payee.bank}`
            this.account_payee_list = [
                account_payee
            ]
            this.value.fill_user_id = data.fill_user_id
            this.value.fill_user = data.fill_user
        },
        show(data) {
            this.value = {}
            this.initValue(data)
            this.dis = true
        },
        ok() {
          const arr = [this.$refs.master]
          let is_ok = true
          let index = 0
          while (this.$refs[`child-${index++}`]) {
            arr.push(this.$refs[`child-${index - 1}`])
          }
          arr.forEach(item => {
            const cur_is_ok = item.validate()
            if (!cur_is_ok) {
              is_ok = false
            }
          })
          if (is_ok) {
            this.saving = true
            updateCostPlanBillApi(this.value).then(() => {
              this.dis = false
              this.$Message.success({content:'编辑成功！'})
              this.$emit('success')
            }).finally(() => {
              this.saving = false
            })
          }
        },
    },
    render() {
        return <VModal 
            dynamicHeight
            heightRate={0.5}
            v-model={this.dis}
            title={this.title}
            loading={this.saving}
            width={800}
            ref="modal"
            on={{
              ok: this.ok
            }}
        >
            <div class={styles['edit-content']}>
                <VForm
                  v-model={this.value} 
                  fields={this.fields}
                  ref="master"
                  scopedSlots={{
                    apply_user_id:({field}) => {
                            return <AutocompletesAsyncS
                            v-model={this.value}
                            field={{
                              ...field,
                              items: this.apply_user_list
                            }}

                            // items: this.apply_user_list
                        />
                    }
                  }}
                />
            </div>
                
            </VModal>
    }
}